// Mock data for form submissions
export const submitContactForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Store in localStorage for demo purposes
  const existingSubmissions = JSON.parse(localStorage.getItem('trademarkSubmissions') || '[]');
  const submission = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  existingSubmissions.push(submission);
  localStorage.setItem('trademarkSubmissions', JSON.stringify(existingSubmissions));
  
  return {
    success: true,
    message: 'Thank you! We will contact you within 24 hours.',
    submissionId: submission.id
  };
};

export const countryCodes = [
  { code: '+1', country: 'United States' },
  { code: '+44', country: 'United Kingdom' },
  { code: '+91', country: 'India' },
  { code: '+61', country: 'Australia' },
  { code: '+86', country: 'China' },
  { code: '+81', country: 'Japan' },
  { code: '+49', country: 'Germany' },
  { code: '+33', country: 'France' },
  { code: '+39', country: 'Italy' },
  { code: '+34', country: 'Spain' },
];
